const endpoints = {
	createProspectChatRoom: '/chats/createProspectChatRoom',
	createUserChatRoom: '/chats/createUserChatRoom',
	createProjectLineChatRoom: '/chats/createProjectLineChatRoom',
	addUserToChatRoom: '/chats/addUserToChatRoom',
	removeUserFromChatRoom: '/chats/removeUserFromChatRoom',
	addMessageToChatRoom: '/chats/addMessageToChatRoom',
	getUserChatRooms: '/chats/getUserChatRooms',
	getChatRoomMessages: '/chats/getChatRoomMessages',
	chatFileToItem: '/chats/chatFileToItem',
	deleteMessageFromChatRoom: '/chats/deleteMessageFromChatRoom',
	getCompanyUserListToChat: '/chats/getCompanyUserListToChat',
	getCompanyProjectLinesToChat: '/chats/getCompanyProjectLinesToChat',
	getProjectLineMessageCounts: '/chats/getProjectLineMessageCounts',
	markMessagesAsSeen: '/chats/markMessagesAsSeen',

	getProjectLineFiles: '/chats/getProjectLineFiles'
}
export {endpoints}